import { Link } from "react-router-dom";

const areas = [
  {
    icon: "ri-hospital-line",
    title: "Health Law",
    desc: "Comprehensive health care regulatory counsel including Medicare, Medicaid, fraud and abuse compliance, and HIPAA privacy protection.",
    href: "/practice-areas/health-law",
    tag: "Core Practice",
  },
  {
    icon: "ri-building-2-line",
    title: "Business Law",
    desc: "Strategic legal support for health care organizations, physician groups, and business entities navigating complex regulatory frameworks.",
    href: "/practice-areas/business-law",
    tag: null,
  },
  {
    icon: "ri-scales-line",
    title: "Litigation",
    desc: "Assertive representation in disputes, administrative proceedings, and enforcement actions focused on favorable client outcomes.",
    href: "/practice-areas/litigation",
    tag: null,
  },
  {
    icon: "ri-file-text-line",
    title: "Contract Disputes",
    desc: "Skilled review, negotiation, and dispute resolution for managed care contracts, employment agreements, and service arrangements.",
    href: "/practice-areas/contract-disputes",
    tag: null,
  },
  {
    icon: "ri-home-office-line",
    title: "Real Estate Law",
    desc: "Legal guidance for health care facility acquisitions, leases, and real property matters across multi-state transactions.",
    href: "/practice-areas/real-estate-law",
    tag: null,
  },
  {
    icon: "ri-secure-payment-line",
    title: "Medicare Compliance",
    desc: "Expert advice on Medicare and Medicaid reimbursement, billing compliance, Stark Law, and anti-kickback statute requirements.",
    href: "/practice-areas/medicare-compliance",
    tag: "High Demand",
  },
];

export default function PracticeAreas() {
  return (
    <section className="bg-white py-24" id="practice-areas">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-14">
          <div className="max-w-xl">
            <span className="block text-[11px] tracking-[0.25em] text-[#C9A961] uppercase font-inter font-medium mb-3">
              Our Expertise
            </span>
            <h2 className="text-4xl lg:text-5xl font-playfair font-bold text-[#0A1628] leading-tight mb-3">
              Practice Areas
            </h2>
            <p className="text-slate-500 font-inter text-base leading-relaxed">
              Specialized health law counsel across the full spectrum of regulatory, compliance,
              and transactional needs.
            </p>
          </div>
          <Link
            to="/practice-areas"
            className="mt-6 lg:mt-0 inline-flex items-center gap-2 text-sm font-inter font-semibold text-[#0A1628] border border-[#0A1628]/20 hover:border-[#C9A961] hover:text-[#C9A961] px-5 py-2.5 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            All Practice Areas
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {areas.map((area) => (
            <Link
              key={area.href}
              to={area.href}
              className="group flex flex-col p-7 rounded-xl border border-slate-100 bg-[#FAFAFA] hover:bg-white hover:border-[#C9A961]/40 transition-all duration-300 cursor-pointer relative overflow-hidden"
            >
              {/* Tag */}
              {area.tag && (
                <span className="absolute top-4 right-4 text-[10px] font-inter font-semibold text-[#C9A961] bg-[#C9A961]/10 border border-[#C9A961]/20 px-2 py-0.5 rounded-full">
                  {area.tag}
                </span>
              )}

              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#0A1628] mb-5 group-hover:bg-[#C9A961] transition-colors duration-300">
                <i
                  className={`${area.icon} text-[#C9A961] text-xl group-hover:text-[#0A1628] transition-colors duration-300`}
                />
              </span>

              <h3 className="text-lg font-playfair font-bold text-[#0A1628] mb-2.5">
                {area.title}
              </h3>
              <p className="text-slate-500 text-sm font-inter leading-relaxed flex-1">{area.desc}</p>

              <div className="flex items-center gap-1.5 mt-5 text-sm font-inter font-semibold text-[#C9A961] translate-x-0 group-hover:translate-x-1 transition-transform duration-200">
                Learn More
                <i className="ri-arrow-right-line" />
              </div>
            </Link>
          ))}
        </div>

        {/* Mid-page CTA */}
        <div className="mt-12 p-7 rounded-xl bg-[#0A1628] flex flex-col sm:flex-row items-center justify-between gap-5">
          <div>
            <p className="text-white font-playfair font-semibold text-lg mb-1">
              Not sure which practice area applies to your situation?
            </p>
            <p className="text-slate-400 text-sm font-inter">
              Schedule a free consultation and we&apos;ll identify the right legal approach for your needs.
            </p>
          </div>
          <Link
            to="/contact"
            className="flex-shrink-0 inline-flex items-center gap-2 bg-[#C9A961] hover:bg-[#b8954f] text-[#0A1628] font-inter font-bold px-6 py-3 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            Free Consultation
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
